import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { createStyles, makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import './Input.css';
export const Input = (props) => {
    const { onFocus, errorIcon, helperText, width, height, label, onChange, onBlur, value = '', name, type = 'active', error = false, rtl = false, className = '', maxLength } = props;
    const dir = rtl ? 'right' : 'left';
    const icon = errorIcon !== '' ? _jsx("img", { src: errorIcon }) : '';
    const inactiveStyles = makeStyles((theme) => createStyles({
        root: {
            '& label.Mui-focused': {
                color: 'rgba(134, 141, 149, 1)',
                borderBottom: 'solid, 12px'
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: 'rgba(134, 141, 149, 1)'
                // borderBottom: '12px'
            },
            '& .MuiInput-underline:before': {
                borderBottom: 'solid, 12px'
            },
            '& > *': {
                margin: theme.spacing(0),
                width: width,
                height: height
            },
        },
    }));
    const inactive = inactiveStyles();
    const activeStyles = makeStyles((theme) => createStyles({
        root: {
            '& label.Mui-focused': {
                color: 'rgba(0, 140, 255, 1)',
            },
            '&.MuiInput-underline:hover': {
                borderBottomColor: 'rgba(0, 140, 255, 1)'
            },
            '& .MuiInput-underline:after': {
                borderBottom: '2px solid rgba(0, 140, 255, 1)'
            },
            '& .MuiInput-underline:before': {
            // borderBottomColor: 'rgba(0, 140, 255, 1)',
            },
            '&..MuiInput-underline:hover:before': {
                borderBottomColor: 'rgba(0, 140, 255, 1)'
            },
            '&.Mui-focused fieldset': {
                borderColor: 'rgba(0, 140, 255, 1)',
            },
            '& > *': {
                margin: theme.spacing(0),
                width: width,
                height: height
            },
        }
    }));
    const active = activeStyles();
    let typeValue;
    let errorFlag;
    switch (type) {
        case 'active':
            typeValue = active.root;
            errorFlag = false;
            break;
        case 'inactive':
            typeValue = inactive.root;
            break;
        case 'error':
            errorFlag = error;
            break;
        default:
            break;
    }
    return (_jsx(_Fragment, { children: _jsx(TextField, { className: `${typeValue} text-field-${dir} ${className}`, error: errorFlag, id: "standard-basic", label: label, name: name, helperText: helperText, onChange: onChange, onBlur: onBlur, value: value, onFocus: onFocus, inputProps: { maxLength: maxLength }, InputProps: {
                endAdornment: (_jsx(InputAdornment, Object.assign({ position: "end" }, { children: icon }))),
            }, style: {
                float: dir
            } }) }));
};
